import { ASSET_LOGO_SRCS } from './assetLogos'

// Fun's icon CDN. Chain logos are SVG; token logos vary (svg/png). {@link FunIcon}
// picks the renderer by extension (SvgXml for `.svg`, Image otherwise).
const CDN_BASE = 'https://sdk-cdn.fun.xyz/images'

/** CDN URL for a chain logo, e.g. `chainIconUri('ethereum')`. SVG. */
export const chainIconUri = (chainKey: string): string =>
  `${CDN_BASE}/${chainKey}.svg`

/**
 * Resolve a deposit token's logo URL by symbol — a verbatim mirror of the web
 * SDK's `getLocalTokenIconUrl` (`packages/connect/src/utils/tokenIconUrl.ts`),
 * the resolver the web *token-transfer* screen uses via `getTokenIconUrl`.
 *
 * IMPORTANT: web's transfer screen resolves the icon PURELY by symbol — it does
 * NOT consult the `/assets/supported` API `logo` field (that field is only used
 * by the wallet-holdings screen, via `getAssetLogoSrc`). The fallback for an
 * unknown symbol is `<symbol>.svg` on the CDN, NOT the dollar-circle. Matching
 * this exactly is why most tokens (USDT/DAI/WETH …) now render: the CDN files
 * are `.svg`, and special cases like POL live in {@link ASSET_LOGO_SRCS}.
 */
export const tokenLogoUri = (symbol: string): string =>
  ASSET_LOGO_SRCS[symbol.toUpperCase()] ??
  `${CDN_BASE}/${symbol.toLowerCase()}.svg`
